import Config from "config";
import loadImageUsingWebWorker from "./loadImage_Webworker";
import loadImageUsingWebWorker2 from "./loadImage_Webworker2";
import loadImageUsingSingleThread from "./loadImage_SingleThread";

let loadImage = loadImageUsingSingleThread;
if (Config.support.webWorker === true) {
  loadImage = loadImageUsingWebWorker;
}

export default loadImage;
